module.exports = __webpack_public_path__ + "static/media/npm.d7ac9e1a.png";